'use es6';

import http from 'conversations-http/clients/http';
export const dismissPrompt = ({
  promptType
}) => http.put(`cv/inbox/settings/v1/user-prompts/dismissed`, {
  query: {
    promptType
  }
});